import { memo, useEffect, useState } from "react";
import { Col, List, Row } from "antd";
import { SubmitButton, TextComponent } from "../../../../../components";
import styles from "./AllChecklist.module.css";
import ProgressBar from "@ramonak/react-progress-bar";
import { useLocation, useNavigate } from "react-router-dom";
import TaskList from "../TaskList/TaskList";
import { CheckListMiddleware } from "../../../../../Store/Middlewares/CheckListMiddleware";
import { useDispatch, useSelector } from "react-redux";

const weekInfo = [
  { date: "4", day: "Saturday" },
  { date: "5", day: "Sunday" },
  { date: "6", day: "Monday" },
  { date: "7", day: "Tuesday" },
  { date: "8", day: "Wednesday" },
  { date: "9", day: "Thursday" },
  { date: "10", day: "Friday" },
];

const tasks = [
  {
    id: 1,
    title: "Wedding Dress",
    completed: false,
    multiple: true,
    subtasks: [
      { title: "Finalize Dress", completed: true },
      { title: "Dress Stitching", completed: false },
    ],
    due: "Tuesday 7",
  },
  { id: 2, title: "Book Florist", completed: true },
  { id: 3, title: "Catering", completed: true },
  { id: 4, title: "Stage Setup", completed: false },
];

const RenderItem = memo(({ info, selectedDate, setSelectedDate }) => {
  const classes =
    selectedDate === info
      ? `${styles.selectedDateRow} ${styles.dateRow}`
      : `${styles.dateRow}`;
  return (
    <List.Item style={{ padding: "0 10px" }}>
      <Row className={classes} onClick={() => setSelectedDate(info)}>
        <Col xs={7} lg={5}>
          <TextComponent textClass={styles.date}>{info.date}</TextComponent>
        </Col>
        <Col xs={17} lg={19}>
          <TextComponent textClass={styles.day}>{info.day}</TextComponent>
        </Col>
      </Row>
    </List.Item>
  );
});

const DaysList = ({ selectedDate, setSelectedDate }) => {
  const navigate = useNavigate();
  return (
    <>
      <Row className={styles.leftHeaderRow}>
        <TextComponent textClass={styles.leftColTitle}>This Week</TextComponent>
        <TextComponent
          textClass={styles.leftColLink}
          onClick={() =>
            navigate("/events/calendar", { state: { headrTitle: "Calendar" } })
          }
        >
          View Calendar
        </TextComponent>
      </Row>
      <List
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 1,
          xl: 1,
          xxl: 1,
        }}
        dataSource={weekInfo.length > 0 ? weekInfo : []}
        renderItem={(info) => (
          <RenderItem
            info={info}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        )}
      />
    </>
  );
};

const AllChecklist = ({ addTaskBtn }) => {
  const navigate = useNavigate();

  const { state } = useLocation();
  const dispatch = useDispatch();

  const ChecklistData = useSelector(
    (state) => state.EventReducer.All_CheckList
  );

  useEffect(() => {
    dispatch(CheckListMiddleware.getCheckList({ id: state?.id }));
  }, []);

  return (
    <>
      {addTaskBtn && (
        <SubmitButton
          title="Add New Task"
          btnClass={styles.btn}
          onClick={() =>
            navigate("/events/eventDetail/addNewTask", {
              state: {
                headrTitle: "Add New Task",
                eventData: state?.eventData,
              },
            })
          }
        />
      )}
      <Row className={styles.statusRow}>
        <Col>
          <TextComponent textClass={styles.statusText}>
            You have completed {ChecklistData?.done ? ChecklistData?.done : "0"}{" "}
            out of{" "}
            {ChecklistData?.checklists?.length > 0
              ? ChecklistData?.checklists.length
              : " 0"}{" "}
            tasks
          </TextComponent>
        </Col>
        <Col>
          <Row style={{ alignItems: "center", margin: "10px 0px" }}>
            <Col className={styles.secondaryDot}></Col>
            <Col>
              <TextComponent>
                To Do ({ChecklistData?.todo ? ChecklistData?.todo : "0"})
              </TextComponent>
            </Col>
            <Col className={styles.secondaryDot}></Col>
            <Col>
              <TextComponent>
                Done ({ChecklistData?.done ? ChecklistData?.done : "0"})
              </TextComponent>
            </Col>
          </Row>
        </Col>
      </Row>
      <ProgressBar
        maxCompleted={
          ChecklistData?.checklists?.length > 0
            ? ChecklistData?.checklists.length
            : 0
        }
        completed={ChecklistData?.done ? ChecklistData?.done : 0}
        className={styles.bar}
        labelClassName={styles.labelBar}
        bgColor="var(--primary-color)"
        height="10px"
      />
      <TaskList
        tasks={
          ChecklistData?.checklists?.length > 0 ? ChecklistData?.checklists : []
        }
        showDueDate
      />
    </>
  );
};

export default AllChecklist;
